import { StudentServiceListsService } from './../service/student-service-lists.service';
import { Component, Inject, OnInit, QueryList, ViewChildren } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatDialogConfig } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { HelpTextComponent } from 'src/app/component/common-components/help-text/help-text.component';
import { MsgModel } from 'src/app/component/common-components/msg/model/msg.model';
import { GradeAgeAlignmentStudentDialogComponent } from 'src/app/component/data-monitoring-reports/grade-age-alignment/grade-age-alignment-student-dialog/grade-age-alignment-student-dialog.component';
import { GradeAgeAlignmentService } from 'src/app/component/data-monitoring-reports/service/grade-age-alignment.service';
import { QuestionHelpText } from 'src/app/model/question-help-text';
import { GetPropertyPipe } from 'src/app/pipes/get-property.pipe';
import { QuestionHelpTextService } from 'src/app/service/question-help-text.service';
import { ServiceReportStudents } from '../model/service-report-students.model';

@Component({
    selector: 'app-service-report-students',
    templateUrl: './service-report-students.component.html',
    styleUrls: ['./service-report-students.component.scss']
})
export class ServiceReportStudentsComponent implements OnInit {
    @ViewChildren(MatPaginator) paginators: QueryList<MatPaginator> = new QueryList<MatPaginator>();
    @ViewChildren(MatSort) sorts: QueryList<MatSort> = new QueryList<MatSort>();

    settings: any = {
        '/reports/student-service-lists': {
            TITLE: 'Student Services - Children List',
            API: undefined,
            SCHOOL_YEAR: true,
            PERFORMANCE_PERIOD: false,
            QUESTION_HELP_TEXT_ID: 0,
            COLUMNS: [
                'SCHOOL.DISTRICT',
                'SCHOOL.NAME',
                'MSD_NUMBER',
                'SSID',
                'PERSON.LAST_NAME',
                'STUDENT_SERVICES[0].GRADES',
                'STUDENT_SERVICES[0].ENROLLMENT_PERIOD',
                'STUDENT_SERVICES[0].START_DATE',
                'STUDENT_SERVICES[0].END_DATE',
                'STUDENT_SERVICES[0].COS_REASONS.REASON'
            ]
        }
    };
    currentSetting: any;

    // Component variables
    resetField: boolean = false;

    // Table display
    displayedColumns: string[] = []; // Dynamically populated based on results + baseDisplayedColumns

    // Tab labels
    selectedIndex: number = 0;

    // Table results
    searchResultDataSource!: MatTableDataSource<ServiceReportStudents>;

    // Results
    results: ServiceReportStudents[] = [];
    searchResultFilter: string = '';

    // Help Text
    lstQuestionHelpText: QuestionHelpText[] = [];

    isLoading: boolean = false;
    msg: MsgModel = {};

    getPropertyPipe = new GetPropertyPipe();

    constructor(
        private studentServiceListsService: StudentServiceListsService,
        private questionHelpTextService: QuestionHelpTextService,
        router: Router,
        private dialog: MatDialog,
        public dialogRef: MatDialogRef<GradeAgeAlignmentStudentDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        this.connectAPIs(studentServiceListsService);
        this.selectSettings(router.url);
        this.search();
    }

    connectAPIs(studentServiceListsService: StudentServiceListsService) {
        this.settings['/reports/student-service-lists'].API = function (payload: any) {
            return studentServiceListsService.getStudentsByPartyService(payload);
        };
    }

    selectSettings(url: string) {
        this.currentSetting = this.settings[url];

        if (this.data.ELEMENT?.SERVICE_HOURS?.NAME === 'Yes') {
            this.currentSetting.COLUMNS = this.currentSetting.COLUMNS.concat('STUDENT_SERVICES[0].SERVICE_HOUR_RANGES.MIN');
        }
    }

    ngOnInit(): void {}

    search() {
        if (true) {
            this.isLoading = true;
            this.msg = {};
            this.searchResultFilter = '';

            this.currentSetting.API(this.generatePayload()).subscribe({
                next: (res: any) => {
                    if (res.students) {
                        this.results = res.students.sort((n1: ServiceReportStudents, n2: ServiceReportStudents) =>
                            n1.PERSON!.LAST_NAME! > n2.PERSON!.LAST_NAME! ? 1 : -1
                        );

                        // Updates the Tables to be displayed w/ this.results
                        this.updateDataSource();
                    } else if (res.msg) {
                        this.results = [];
                        this.msg = res.msg;
                    } else {
                        this.results = [];
                        this.msg = { SUCCESS: false, MSG: 'Error retrieving ' + this.currentSetting.TITLE + '.' };
                    }
                },
                error: (err: any) => {
                    this.results = [];
                    this.msg = { SUCCESS: false, MSG: 'Error retrieving ' + this.currentSetting.TITLE + '.' };
                },
                complete: () => {
                    // Display results
                    this.isLoading = false;

                    // Set to first tab
                    this.selectedIndex = 0;
                }
            });
        }
    }

    generatePayload(): any {
        let payload: any = {};

        payload.chosenRegions = this.data?.CURRENT.CODE ? [this.data?.CURRENT.ID] : this.data?.chosenRegions;
        payload.chosenCounties = this.data?.CURRENT.COUNTY_NAME ? [this.data?.CURRENT.ID] : this.data?.chosenCounties;
        payload.chosenSchoolDistricts = this.data?.CURRENT.DISTRICTS ? [this.data?.CURRENT.ID] : this.data?.chosenSchoolDistricts;
        payload.chosenSchools = this.data?.CURRENT.SCHOOL_NAME ? [this.data?.CURRENT.ID] : this.data?.chosenSchools;
        payload.performancePeriod = this.data?.performancePeriod;

        payload.expiredEligibility = this.data.expiredEligibility;
        payload.expiredQAD = this.data.expiredQAD;
        payload.emptyActiveServices = this.data.emptyActiveServices;

        payload.grades = this.data.grades;
        payload.partyServices = this.data.partyServices;
        payload.enrollmentPeriods = this.data.enrollmentPeriods;
        payload.serviceCategories = this.data.serviceCategories;

        payload.partyServices = [this.data.ELEMENT.PARTY_SERVICE_ID];

        return payload;
    }

    updateDataSource() {
        setTimeout(() => {
            this.updateResultDataSource();
        });
    }
    updateResultDataSource() {
        // Display Columns
        this.displayedColumns = this.currentSetting.COLUMNS;

        // Data
        this.searchResultDataSource = new MatTableDataSource<ServiceReportStudents>();
        this.searchResultDataSource.data = this.results;

        // Paginator
        this.searchResultDataSource.paginator = this.paginators.toArray()[0];

        // Sort
        this.searchResultDataSource.sort = this.sorts.toArray()[0];
        const defaultSort: Sort = { active: 'MSD_NUMBER', direction: 'asc' };
        this.searchResultDataSource.sort.active = defaultSort.active;
        this.searchResultDataSource.sort.direction = defaultSort.direction;
        this.searchResultDataSource.sort.sortChange.emit(defaultSort);
        this.searchResultDataSource.sortingDataAccessor = (obj, property) => this.getPropertyPipe.transform(obj, property, true);

        // Filter
        this.searchResultDataSource.filterPredicate = (data: any, filter) => {
            const dataStr = JSON.stringify(data).toLowerCase();
            return dataStr.indexOf(filter) != -1;
        };
    }

    setFilter(searchResultDataSource: any, filter: string) {
        searchResultDataSource.filter = filter.trim().toLocaleLowerCase();
    }

    toNumberArray(array: any[]): number[] {
        let returnArray: number[] = [];

        array.forEach((obj) => {
            obj.ID ? returnArray.push(obj.ID) : null;
        });

        return returnArray;
    }

    // Help Text
    invokeHelpTextAPI() {
        this.questionHelpTextService.getHelpText(this.currentSetting.QUESTION_HELP_TEXT_ID).subscribe((lstQuestionHelpText: QuestionHelpText[]) => {
            this.lstQuestionHelpText = lstQuestionHelpText;
        });
    }

    displayHelpText(qId: number) {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.autoFocus = true;
        dialogConfig.maxHeight = '80vh';
        dialogConfig.data = this.returnHelpText(qId);
        const dialogRef = this.dialog.open(HelpTextComponent, dialogConfig);
    }

    returnHelpText(qId: number): string {
        let questionHelpText = this.lstQuestionHelpText.find((x) => x.QUESTIONS_ID == qId);

        if (questionHelpText) return questionHelpText?.HELP_TEXT;
        else return '';
    }
}
